import { DynamicPage, getDynamicPageProps } from '$templates/pages';

export const getServerSideProps = getDynamicPageProps;
export default DynamicPage;
